const filterRowsWithDifference = (table) => {
  if (!table) throw Error('No table found');

  const tbody = table.querySelector('tbody');
  const rows = [...tbody.rows];

  const filteredRows = rows.filter((row) => {
    const [, secondCell, thirdCell] = row.cells;
    const secondCellContent = secondCell.innerText;
    const thirdCellContent = thirdCell.innerText;

    return secondCellContent !== thirdCellContent;
  });

  return filteredRows;
};

export default filterRowsWithDifference;
